export const enum InstallAppSourceScreen {
	Footer = "Footer",
	DiscoveryPage = "Discovery page feed section",
	Snackbar = "Bottom page snack bar", //smartbanner
	HRCampaign = "HR Campaign",
	Referral = "Referral",
};

export const GA4Events = {
	view: {
		landing: "View_Landing_Page_Screen",
		delivery: "View_Delivery_Screen",
		dineOut: "View_DineOut_Screen",
		offers: "View_Offers_Screen",
		locationPrompt: "View_Location_Prompt_Screen",
		restaurant: "View_Restaurant_Screen",
		callPrompt: "View_Call_Prompt_Screen",
	},
	action:{
		clickOnArea: "Action_Click_On_Area",
		clickOnZone: "Action_Click_On_Zone",
		viewBasket: "Action_View_Basket",
		createBasket: "Action_Create_Basket",
		clickOnRestaurant: "Action_Clicked_On_Restaurant",
		addItemToBasket: "Action_Add_Item_To_Basket",
		applyPromo: "Action_Apply_Promo",
		installApp: "Action_Install_App",
		placeOrderSuccess: "Action_Place_Order_Success",
		callRestaurant: "Action_Call_Restaurant",
		callPromptOrderOnline: "Action_Call_Prompt_Order_Online",
		deliveryTime: "Action: Delivery time confirmation",
	},
	screen: {
		deliverTimePrompt: "Screen: Order delivery time prompt",
	}
};
